import api from "services/api";
import dataFetcher from "modules/dataFetcher";

export const systemActivationFetcher = dataFetcher({
  selectors: ["system", "activation"],
  async fetchData() {
    try {
      return await api.get("v1/activations/system");
    } catch (err) {
      return;
    }
  },
});
